import { render, staticRenderFns } from "./articleListComponent.vue?vue&type=template&id=4369900e&scoped=true&"
import script from "./articleListComponent.vue?vue&type=script&lang=js&"
export * from "./articleListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4369900e",
  null
  
)

export default component.exports